webpackJsonp([90],{

/***/ 1212:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            data: [{
                name: 'Board Games',
                sold: 131,
                available: 301,
                items: [{
                    name: 'Monopoly',
                    sold: 57,
                    available: 100
                }, {
                    name: 'Scrabble',
                    sold: 23,
                    available: 84
                }, {
                    name: 'Chess',
                    sold: 37,
                    available: 61
                }, {
                    name: 'Battleships',
                    sold: 14,
                    available: 56
                }]
            }, {
                name: 'Jigsaws & Puzzles',
                sold: 88,
                available: 167,
                items: [{
                    name: 'World Map',
                    sold: 31,
                    available: 38
                }, {
                    name: 'London',
                    sold: 23,
                    available: 29
                }, {
                    name: 'Sharks',
                    sold: 20,
                    available: 44
                }, {
                    name: 'Disney',
                    sold: 14,
                    available: 56
                }]
            }, {
                name: 'Books',
                sold: 434,
                available: 721,
                items: [{
                    name: 'Hamlet',
                    sold: 101,
                    available: 187
                }, {
                    name: 'The Lord Of The Rings',
                    sold: 85,
                    available: 156
                }, {
                    name: 'To Kill a Mockingbird',
                    sold: 78,
                    available: 131
                }, {
                    name: 'Catch-22',
                    sold: 73,
                    available: 98
                }, {
                    name: 'Frankenstein',
                    sold: 51,
                    available: 81
                }, {
                    name: 'Alice\'s Adventures In Wonderland',
                    sold: 46,
                    available: 68
                }]
            }],
            columnsVisible: {
                name: { title: 'Name', display: true },
                sold: { title: 'Stock Sold', display: true },
                available: { title: 'Stock Available', display: true },
                cleared: { title: 'Stock Cleared', display: true }
            },
            showDetailIcon: true
        };
    },

    methods: {
        toggle: function toggle(row) {
            this.$refs.table.toggleDetails(row);
        }
    }
});

/***/ }),

/***/ 1213:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": ""
    }
  }, [_c('div', {
    staticClass: "control"
  }, [_c('b-checkbox', {
    model: {
      value: (_vm.showDetailIcon),
      callback: function($$v) {
        _vm.showDetailIcon = $$v
      },
      expression: "showDetailIcon"
    }
  }, [_vm._v("Detail column")])], 1), _vm._v(" "), _vm._l((_vm.columnsVisible), function(column, index) {
    return _c('div', {
      key: index,
      staticClass: "control"
    }, [_c('b-checkbox', {
      model: {
        value: (column.display),
        callback: function($$v) {
          _vm.$set(column, "display", $$v)
        },
        expression: "column.display"
      }
    }, [_vm._v("\n                    " + _vm._s(column.title) + "\n                ")])], 1)
  })], 2), _vm._v(" "), _c('b-table', {
    ref: "table",
    attrs: {
      "data": _vm.data,
      "detailed": "",
      "hoverable": "",
      "custom-detail-row": "",
      "opened-detailed": ['Board Games'],
      "default-sort": ['name', 'asc'],
      "detail-key": "name",
      "show-detail-icon": _vm.showDetailIcon
    },
    on: {
      "details-open": function (row, index) { return _vm.$buefy.toast.open(("Expanded " + (row.name))); }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('b-table-column', {
          attrs: {
            "field": "name",
            "visible": _vm.columnsVisible['name'].display,
            "label": _vm.columnsVisible['name'].title,
            "width": "300",
            "sortable": ""
          }
        }, [(_vm.showDetailIcon) ? [_vm._v("\n                        " + _vm._s(props.row.name) + "\n                    ")] : [_c('a', {
          on: {
            "click": function($event) {
              _vm.toggle(props.row)
            }
          }
        }, [_vm._v("\n                            " + _vm._s(props.row.name) + "\n                        ")])]], 2), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "sold",
            "visible": _vm.columnsVisible['sold'].display,
            "label": _vm.columnsVisible['sold'].title,
            "sortable": "",
            "centered": ""
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.sold) + "\n                ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "available",
            "visible": _vm.columnsVisible['available'].display,
            "label": _vm.columnsVisible['available'].title,
            "sortable": "",
            "centered": ""
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.available) + "\n                ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "visible": _vm.columnsVisible['cleared'].display,
            "label": _vm.columnsVisible['cleared'].title,
            "centered": ""
          }
        }, [_c('span', {
          class: [
            'tag',
            {
              'is-danger': props.row.sold / props.row.available <= 0.45
            },
            {
              'is-success': props.row.sold / props.row.available > 0.45
            }
          ]
        }, [_vm._v("\n                        " + _vm._s(Math.round((props.row.sold / props.row.available) * 100)) + "%\n                    ")])])]
      }
    }, {
      key: "detail",
      fn: function(props) {
        return _vm._l((props.row.items), function(item) {
          return _c('tr', {
            key: item.name
          }, [(_vm.showDetailIcon) ? _c('td') : _vm._e(), _vm._v(" "), _c('td', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (_vm.columnsVisible['name'].display),
              expression: "columnsVisible['name'].display"
            }]
          }, [_vm._v("    " + _vm._s(item.name))]), _vm._v(" "), _c('td', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (_vm.columnsVisible['sold'].display),
              expression: "columnsVisible['sold'].display"
            }],
            staticClass: "has-text-centered"
          }, [_vm._v(_vm._s(item.sold))]), _vm._v(" "), _c('td', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (_vm.columnsVisible['available'].display),
              expression: "columnsVisible['available'].display"
            }],
            staticClass: "has-text-centered"
          }, [_vm._v(_vm._s(item.available))]), _vm._v(" "), _c('td', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (_vm.columnsVisible['cleared'].display),
              expression: "columnsVisible['cleared'].display"
            }],
            staticClass: "has-text-centered"
          }, [_c('span', {
            class: [
              'tag',
              {
                'is-danger': item.sold / item.available <= 0.45
              },
              {
                'is-success': item.sold / item.available > 0.45
              }
            ]
          }, [_vm._v("\n                            " + _vm._s(Math.round((item.sold / item.available) * 100)) + "%\n                        ")])])])
        })
      }
    }])
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 292:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1212),
  /* template */
  __webpack_require__(1213),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/90.6970ffd424bb24983267.js